export const getPanelTransitionProps = (onOpenStart, onOpenComplete, onCloseStart, onCloseComplete, align, animate, zIndex, topOffset) => ({
  onOpenStart,
  onOpenComplete,
  onCloseStart,
  onCloseComplete,
  align,
  duration: animate ? undefined : 0,
  zIndex,
  topOffset
});